<template>
  <Modal
    :open="open"
    @close-modal="$emit('close-modal')"
    customHeight="h-180"
    customWidth="lg:w-220"
  >
    <template v-slot:modal-header>
      <div>
        <div class="flex items-center">
          <Icon name="Eye" class="w-4 h-4 mr-1 stroke-info" />
          <div class="text-sm font-inter font-semibold text-info">
            Preview {{ file.file_name }}
          </div>
        </div>
        <div class="font-league tracking-[-.56px] font-semibold text-[1.75rem] text-strongest">
          Preview Document
        </div>
      </div>
    </template>

    <template v-slot:modal-body>
      <div class="h-full">
        <div
          v-if="
            file.file_type ===
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
          "
          class="h-full overflow-auto"
        >
          <div
            class="m-4 rounded border border-platform-outlines bg-white p-4"
            v-html="docContent"
          ></div>
        </div>

        <object
          v-else
          :data="file.file_url"
          :type="file.file_type"
          class="h-full w-full"
        ></object>
      </div>
    </template>

    <template v-slot:modal-footer>
      <div class="flex flex-row justify-end gap-1">
        <Button size="md" variant="paper-primary" @click="$emit('close-modal')">
          <template #label>Close</template>
        </Button>
        <Button size="md" @click="handleDownload">
          <template #label>Download</template>
        </Button>
      </div>
    </template>
  </Modal>
</template>

<script setup>
import { ref, watch } from "vue";
import mammoth from "mammoth";

import { Button, Icon, Modal } from "@/components";

import useFileUtility from "@/composables/useFileUtility";

const { downloadFile_R2 } = useFileUtility();
const emit = defineEmits(["close-modal"]);

const docContent = ref("");

const props = defineProps({
  open: {
    type: Boolean,
    required: true,
  },
  file: {
    type: [Object, null],
    required: true,
  },
});

async function handleDownload() {
  await downloadFile_R2(props.file.entry);
}

watch(
  () => props.file,
  async (newVal) => {
    if (!newVal) {
      return;
    }

    if (!newVal.file_url || typeof newVal.file_url !== "string") {
      return;
    }

    try {
      const response = await fetch(newVal.file_url);

      if (!response.ok) {
        return;
      }

      const arrayBuffer = await response.arrayBuffer();

      if (
        newVal.file_type !==
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      ) {
        return;
      }

      const result = await mammoth.convertToHtml({ arrayBuffer });

      docContent.value = result.value;
    } catch (error) {
      console.error("[DocumentPreviewModal] Error processing file:", error);
    }
  },
  { immediate: true }
);
</script>
